import React, { FC, Suspense } from 'react'
import Box from '@mui/material/Box'
import { Switch } from 'react-router'
import { Route } from 'react-router-dom'
import { CircularProgress } from '@mui/material'
import {
	PAGE_USER_COACH_ASSIGNED,
	PAGE_USER,
	PAGE_USER_COACH_HISTORY,
} from '../../../../../../constants/navigation'
import theme from '../../../../../../theme'

const CoachOverviewMainGeneral = React.lazy(
	() =>
		import(
			// eslint-disable-next-line max-len
			/* webpackChunkName: "patient_overview_dashboard" */ './CoachOverviewMainGeneral/CoachOverviewMainGeneral'
		)
)
const CoachOverviewMainAssigned = React.lazy(
	() =>
		import(
			// eslint-disable-next-line max-len
			/* webpackChunkName: "patient_overview_dashboard" */ './CoachOverviewMainAssigned/CoachOverviewMainAssigned'
		)
)
const CoachOverviewMainHistory = React.lazy(
	() =>
		import(
			// eslint-disable-next-line max-len
			/* webpackChunkName: "patient_overview_dashboard" */ './CoachOverviewMainHistory/CoachOverviewMainHistory'
		)
)

const PatientOverviewMain: FC = () => {
	return (
		<Box
			component={'main'}
			flexGrow={1}
			bgcolor={theme.palette.grey[100]}
			pl={{ xs: 8, xl: 16 }}
			pr={8}
			py={10}
			display={'flex'}
			flexDirection={'column'}
		>
			<Switch>
				<Route exact={true} path={PAGE_USER}>
					<Suspense
						fallback={
							<Box
								display={'flex'}
								alignItems={'center'}
								justifyContent={'center'}
								my={'auto'}
							>
								<CircularProgress />
							</Box>
						}
					>
						<CoachOverviewMainGeneral />
					</Suspense>
				</Route>
			</Switch>
			<Switch>
				<Route exact={true} path={PAGE_USER_COACH_ASSIGNED}>
					<Suspense
						fallback={
							<Box
								display={'flex'}
								alignItems={'center'}
								justifyContent={'center'}
								my={'auto'}
							>
								<CircularProgress />
							</Box>
						}
					>
						<CoachOverviewMainAssigned />
					</Suspense>
				</Route>
			</Switch>
			<Switch>
				<Route exact={true} path={PAGE_USER_COACH_HISTORY}>
					<Suspense
						fallback={
							<Box
								display={'flex'}
								alignItems={'center'}
								justifyContent={'center'}
								my={'auto'}
							>
								<CircularProgress />
							</Box>
						}
					>
						<CoachOverviewMainHistory />
					</Suspense>
				</Route>
			</Switch>
		</Box>
	)
}

export default PatientOverviewMain
